import { useWatch } from 'react-hook-form';

import { InviteEligibilityBanner } from './invite-eligibility-banner';
import {
  useInviteEligibilityCheck,
  type InviteEligibilityRowFilter,
} from '../hooks/use-invite-eligibility-check';

export function InviteEligibilityApplicantNotice({
  index,
  includeRow,
}: {
  index: number;
  /** Must match the controller's filter so the banner reads the same query. */
  includeRow?: InviteEligibilityRowFilter;
}) {
  const { isFeatureEnabled, isStale, getApplicant } = useInviteEligibilityCheck({ includeRow });
  const formEmail = useWatch({ name: `applicants.${index}.email` }) as string | null | undefined;

  if (!isFeatureEnabled || isStale) {
    return null;
  }

  const applicant = getApplicant(index);
  if (!applicant || applicant.outcome === 'allow') {
    return null;
  }

  const email = applicant.email.trim() || formEmail?.trim() || '';
  if (!email) {
    return null;
  }

  return (
    <InviteEligibilityBanner
      outcome={applicant.outcome}
      email={email}
      totalMatches={applicant.total_matches}
      reason={applicant.reason}
    />
  );
}
